import React from 'react';

import { useRecoilValue, RecoilState } from 'recoil';
import { FormControl, Text } from '@tq/ui-components';

import { IsRegisteredCheckbox } from 'components';

interface IsRegisteredTableCellProps {
  rowValue: string;
  isRegisteredRowValue: boolean;
  editingState: RecoilState<number | undefined>;
  isRegisteredState: RecoilState<string>;
  rowIndex: number;
  label: string;
}

export const IsRegisteredTableCell: React.FC<IsRegisteredTableCellProps> = ({
  rowValue,
  editingState,
  isRegisteredState,
  rowIndex,
  label,
  isRegisteredRowValue,
}) => {
  const currentEditRowIndex = useRecoilValue(editingState);
  return currentEditRowIndex === rowIndex ? (
    <FormControl width='100%'>
      <IsRegisteredCheckbox
        recoilState={isRegisteredState}
        label={label}
        inputId='input-is-registered'
        defaultValue={isRegisteredRowValue ? 'true' : 'false'}
      />
    </FormControl>
  ) : (
    <Text>{rowValue}</Text>
  );
};
